import IndexRoute from './IndexRoute';

export default IndexRoute;
